<template>
  <div class="desc-container"
    v-if="selectedTarotBox?.screenShotImgUrlList">
    <div class="desc-title">
      <div class="title2">미리보기</div>
    </div>
    <div class="carousel-wrapper">
      <Swiper
          :modules="swiperModules"
          :slides-per-view="'auto'"
          :space-between="8"
          :threshold="5"
          :free-mode="{ enabled: true, sticky: true }"
          @touchEnd="swipeImagePopup"
      >
        <SwiperSlide
            v-for="(slide, index) in selectedTarotBox.screenShotImgUrlList"
            :key="index"
        >
          <div class="carousel_item" @click="openImagePopup(index, slide)">
            <ShimmerImage
                :src="slide"
                :imageStyle="{ width: '180px' }"
                :heightRatio="1.66"
                :isCircle="false"
                :borderRadius="'8px'"/>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
    <ScreenShotPopup
        :isActive="imagePopupActive"
        :closePopupCallback="closePopupCallback"
        :numberOfCarousel="numberOfCarousel"
        :currentSlideIndex="currentSlideIndex"
        :selectedTarotBox="selectedTarotBox"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ShimmerImage from "@/tarot_box/components/shimmer/ShimmerImage.vue";
import {Swiper, SwiperSlide} from 'swiper/vue';
import {FreeMode} from 'swiper/modules';
import ScreenShotPopup from "@/tarot_box/pages/home/components/tarot_box_detail/components/ScreenshotPopup";
import {logEvent} from "@/tarot_box/helper/native_api";

import 'swiper/css';

export default {
  name: "TarotDetailTableOfContents",
  components: {
    ShimmerImage,
    ScreenShotPopup,
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      swiperModules: [FreeMode],
      numberOfCarousel: 0,
      selectedImage: '',
      imagePopupActive: false,
      currentSlideIndex: 0,
    };
  },
  props: {
    selectedTarotBox: {
      type: Object,
    },
    imageLoaded: {
      type: Boolean,
    },
  },
  mounted() {},
  computed: {
    ...mapGetters(["tarotBoxes"]),
  },
  methods: {
    openImagePopup(index, slide){
      this.currentSlideIndex = index;
      this.selectedImage = slide;
      this.imagePopupActive = true;
      logEvent("snack_detail_shot_click", {tarot_box_id: this.selectedTarotBox.id});
    },
    swipeImagePopup(){
      if(this.imageLoaded === true){
      logEvent('snack_detail_shot_swipe', {tarot_box_id: this.selectedTarotBox.id});
      }
    },
    closePopupCallback(){
      this.imagePopupActive = false;
    },
  }
};
</script>


<style scoped>
.desc-container {
  width: 100%;
  padding: 30px 16px;
  border-bottom: 0.5px solid var(--Grayscale-Gray8);
  text-align: left;
}
.carousel-wrapper{
  width: 100%;
  overflow-x: hidden;
}

:deep(.swiper-slide) {
  width: 180px !important;
}

.carousel_item {
  margin: 12px 0 0 0;
  border: 0.5px solid var(--Grayscale-Gray9);
  border-radius: 8px;
}
</style>
